import { render, staticRenderFns } from "./payment-dialog.vue?vue&type=template&id=b10cd4a6&scoped=true"
import script from "./payment-dialog.vue?vue&type=script&lang=js"
export * from "./payment-dialog.vue?vue&type=script&lang=js"
import style0 from "./payment-dialog.vue?vue&type=style&index=0&id=b10cd4a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b10cd4a6",
  null
  
)

export default component.exports